import { render, staticRenderFns } from "./PendingActivationList.vue?vue&type=template&id=2a10e1b6"
import script from "./PendingActivationList.vue?vue&type=script&lang=js"
export * from "./PendingActivationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports